export const LOGIN_ERROR_LABEL = 'Login failed, please check your domain/username/password and allow pop-ups';
export const LOGIN_WRONG_DOMAIN = 'Please check your domain';
